import Media from "apiEndPoints/Media";
import { MultiUpload } from "components/Antd";
import { useState } from "react";
import { Link } from "react-router-dom";

function Step3uploader({
  props,
  imageArray,
  setImageArray,
  imageErr,
  setImageArraySize,
  imageArraySize,
  subscriptionData,
}) {
  const [imageLoading, setImageLoading] = useState(false);

  const mediaUrl = (data) => {
    let tempArray = imageArray;
    let tempArraySize = imageArraySize;
    const { basePath, baseUrl, fileSize } = data;
    tempArraySize.push(fileSize);
    tempArray.push({ basePath, baseUrl });
    setImageArray([...tempArray]);
    setImageArraySize([...tempArraySize]);
  };
  const removeImage = (setFieldValue, index) => {
    let tempArray = imageArray;
    let tempArraySize = imageArraySize;
    tempArray.splice(index, 1);
    tempArraySize.splice(index, 1);
    if (tempArray.length === 0) {
      setFieldValue("coverImage", "");
    }
    setImageArray([...tempArray]);
    setImageArraySize([...tempArraySize]);
  };
  return (
    <>
      <div className="commonCard bg-white">
        <div className="commonCard_head">
          <h2 className="mb-0">Banner Photos</h2>
        </div>
        <div className="d-flex flex-wrap">
          {imageArray.map((item, index) => {
            return (
              <div className="customUpload customUpload-icon multiUpload">
                <div className="ant-form-item-control-input-content">
                  <span className="ant-upload-wrapper avatar-uploader css-dev-only-do-not-override-1k979oh ant-upload-picture-card-wrapper">
                    <div className="ant-upload ant-upload-select ant-upload-disabled">
                      <span className="ant-upload ant-upload-disabled">
                        <Link
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            removeImage(props.setFieldValue, index);
                          }}
                          className="position-absolute d-flex justify-content-center align-items-center uploadDelete"
                        >
                          <em className="icon-delete mb-0" />
                        </Link>
                        <img
                          src={item.baseUrl}
                          alt="bannerImage"
                          className="w-100"
                        />
                      </span>
                    </div>
                  </span>
                </div>
                {/* <Upload
                  name="coverImage"
                  setFieldValue={props.handleChange}
                  disabled
                >
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      removeImage(props.setFieldValue, index);
                    }}
                    className="position-absolute d-flex justify-content-center align-items-center uploadDelete"
                  >
                    <em className="icon-delete mb-0" />
                  </Link>
                  <img src={item.baseUrl} alt="bannerImage" className="w-100" />
                </Upload> */}
              </div>
            );
          })}
          {imageArray?.length < 5 && (
            <div className="customUpload customUpload-icon">
              {imageArray?.length < 5 && (
                <MultiUpload
                  name="coverImage"
                  setFieldValue={props.handleChange}
                  apiEndPoints={Media.mediaUpload("memorial", "image")}
                  query
                  subscriptionData={subscriptionData}
                  applyImageCropper
                  mediaUrl={mediaUrl}
                  aspect={0.65}
                  // validateFileType={["image/png", "image/jpeg"]}
                  imageLoading={imageLoading}
                  setImageLoading={setImageLoading}
                >
                  <div>
                    <em className="icon-upload" />
                    <span className="d-block">Upload Photo</span>
                  </div>
                </MultiUpload>
              )}
            </div>
          )}
        </div>
        {imageErr === true && (
          <div
            style={{
              display: "flex",
              flexWrap: "nowrap",
              color: "#ff4d4f",
            }}
          >
            <div
              className="ant-form-item-explain ant-form-item-explain-connected css-dev-only-do-not-override-1k979oh"
              role="alert"
            >
              <div className="ant-form-item-explain-error">
                Please upload 5 cover image
              </div>
            </div>
          </div>
        )}
      </div>{" "}
    </>
  );
}

export default Step3uploader;
